import {
  DollarSign, Lock, Store, ClipboardList, Plus, Wallet, Clock,
  FileText, Monitor, Settings, UserCheck
} from "lucide-react";
import POSHeader from "./POSHeader";

export default function POSHome({ onNavigate, restaurantName, caixaAberto }) {
  // Todas as opções do POS como app dedicado
  const tiles = [
    { id: "abrir_caixa", icon: DollarSign, label: "Abrir Caixa", hidden: caixaAberto },
    { id: "fechar_caixa", icon: Lock, label: "Fechar Caixa", hidden: !caixaAberto },
    { id: "venda", icon: Store, label: "Venda direta", disabled: !caixaAberto },
    { id: "pedido_balcao", icon: UserCheck, label: "Pedido c/ Cliente", disabled: !caixaAberto },
    { id: "contas", icon: ClipboardList, label: "Contas / Mesas", disabled: !caixaAberto },
    { id: "novo_pedido", icon: Plus, label: "Novo pedido", disabled: !caixaAberto },
    { id: "pagamentos", icon: Wallet, label: "Pagamentos" },
    { id: "pedidos", icon: Clock, label: "Pedidos" },
    { id: "recibos", icon: FileText, label: "Recibos" },
    { id: "auto", icon: Monitor, label: "Balcão" },
    { id: "config", icon: Settings, label: "Configuracoes" },
  ].filter(t => !t.hidden);

  return (
    <div className="min-h-screen bg-[#f5f5f5] flex flex-col" data-testid="pos-home">
      <POSHeader title={restaurantName || "KAISO POS"} icon={null} />
      {!caixaAberto && (
        <div className="bg-amber-100 border-b border-amber-200 px-4 py-2 text-center">
          <span className="text-amber-700 text-sm font-medium">Caixa fechado - Abra o caixa para iniciar vendas</span>
        </div>
      )}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="grid grid-cols-2 gap-3 sm:gap-4 w-full max-w-md">
          {tiles.map(tile => (
            <button
              key={tile.id}
              onClick={() => !tile.disabled && onNavigate(tile.id)}
              className={`bg-white rounded-xl border border-gray-200 p-5 sm:p-6 flex flex-col items-center gap-2.5 transition-all active:scale-95 ${
                tile.disabled ? "opacity-50 cursor-not-allowed" : "hover:shadow-lg hover:border-emerald-300"
              } ${tile.id === "abrir_caixa" ? "bg-emerald-50 border-emerald-300" : ""} ${tile.id === "fechar_caixa" ? "bg-red-50 border-red-300" : ""}`}
              data-testid={`pos-tile-${tile.id}`}
            >
              <tile.icon className={`w-8 h-8 ${tile.id === "abrir_caixa" ? "text-emerald-600" : tile.id === "fechar_caixa" ? "text-red-600" : "text-emerald-600"}`} strokeWidth={1.5} />
              <span className="text-xs sm:text-sm font-semibold text-gray-700 text-center leading-tight">{tile.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
